// this is going to be global contract in the lib
import { Event } from "../../contracts";
import { eBranches } from "sb-resp-lib";

export const mapGamePart = (x: Event) => {
    x.gamePart = x.liveGameState && x.liveGameState.gamePart && x.sportId !== eBranches.Tennis.toString()
        ? x.liveGameState.gamePart : "";
    return x;
}